import React, { useState } from "react";
import "./Form.css";
import ExpensesInput from "./ExpensesInput";

function Form(props) {
  const [visible, setVisible] = useState(false);

  const getExpenses = (getExpense) => {
    const data = {
      ...getExpense,
      id: Math.random(),
    };
    props.getData(data);

    setVisible(false);
  };

  function hideForm() {
    setVisible(false);
  }

  return (
    <div className="new-expense ">
      {visible && <ExpensesInput onSaveExpense={getExpenses} onCancel={hideForm} />}
      {!visible && (
        <button onClick={() => setVisible(true)}>Add New Expense</button>
      )}
    </div>
  );
}

export default Form;
